export default {
  rememberMe: state => {
    return state.rememberMe
  },
  login: state => {
    return state.login
  },
  password: state => {
    return state.password
  },
  isError: state => {
    return state.isError
  },
}
